var homeURL = 'http://' + window.location.hostname + ':3000';
var apiURL = 'http://' + window.location.hostname + ':8765';
var apiSocketURL = 'ws://' + window.location.hostname + ':8765';
var shareURL = 'http://' + window.location.hostname + ':8766';

if (process.env.NODE_ENV === 'production') {
    homeURL = 'https://drawesome.31415926535.uk';
    apiURL = 'https://drawesomeapi.31415926535.uk';
    apiSocketURL = 'wss://drawesomeapi.31415926535.uk';
    shareURL = 'https://drawesomeshare.31415926535.uk';
}

const URLs = {
    homeURL: homeURL,
    apiURL: apiURL,
    apiSocketURL: apiSocketURL,
    shareURL: shareURL,
}

export default URLs;
